import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { CGUModal } from './Modals/CGUModal';

const Footer: React.SFC<RouteComponentProps> = ({ location }) => 
{
  const [toogle, setToogle] = React.useState({
   CGUModalIsOpen: false ,
  });

    const toggleUCGModal = () =>
    setToogle({
        CGUModalIsOpen: !toogle.CGUModalIsOpen,
    });


  return (
  <>
  <Row
    tag='footer'
    className={`d-flex align-items-center bg-${
      location.pathname === '/' ? 'white' : 'dark'
    } text-center p-3 pl-sm-5 pr-sm-5`}
  > 
  {location.pathname === '/'  ? (
    <Col md='8' xs='12' className='d-flex justify-content-left flex-column flex-md-row'>      
       
              {/* <Link to='#' className={`text-${location.pathname === '/' ? 'dark' : 'white'}`}>Mentions légales</Link> */}
              <Link to='#' onClick={toggleUCGModal} className={`text-${location.pathname === '/' ? 'dark' : 'white'}`}>CGU</Link>
              {/* <Link to='#' className={`text-${location.pathname === '/' ? 'dark' : 'white'}`}>Protection des données</Link> */}
              {/* <Link to='#' className={`text-${location.pathname === '/' ? 'dark' : 'white'}`}>Politiques des cookies</Link> */}
    </Col>
  )
  :
  <Col md='8' xs='12' className='d-flex justify-content-between flex-column flex-md-row'/> 
}
    <Col md='4' xs='12' className='d-flex justify-content-sm-end justify-content-center'>
      <Link to='#' className={`text-${location.pathname === '/' ? 'dark' : 'white'}`}>Beadvize 2019</Link>
    </Col>
  </Row>
  <CGUModal 
    isOpen={toogle.CGUModalIsOpen}
    toggleUCGModal={toggleUCGModal}
  />
  </>
);
};
export const FooterWithRouter = withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/shared/Footer.tsx